import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import betslip from '@gin-betting/betslip';
import core from '@gin-betting/core';
import cn from 'classnames';
import cd from 'debug';
import { compose } from 'redux';
import { createSelector } from 'reselect';

import { CheckBox } from 'components';
import messages from '../../../messages';

import './CheckListItem.scss';

const {
    hocs: { withPure, withPropsValidation },
} = core;
const {
    selectors: { selectCombinations },
} = betslip;
const {
    actions: { toggleSystemCombination },
} = betslip;

const debug = cd('app:betslip:components:CheckListItem');

interface OwnProps {
    combinationNumber: number;
    betslipBetId: string;
}

interface MappedActions {
    toggleSystemCombination: typeof toggleSystemCombination;
}

interface MappedProps {
    betslipOddsSize: number | undefined;
    isChosen: boolean | undefined;
}

type RawProps = OwnProps & MappedProps & MappedActions;
type Props = RawProps & {
    betslipOddsSize: number;
    isChosen: boolean;
};

class CheckListItem extends React.Component<Props, {}> {
    handleSelect = () => {
        const { combinationNumber, betslipBetId } = this.props;

        this.props.toggleSystemCombination({ betslipBetId, combinationNumber });
    };

    render() {
        debug('render', this.props);

        const { combinationNumber, isChosen, betslipOddsSize } = this.props;

        return (
            <div
                className="__app-CheckListItem-wrapper"
                styleName={cn('wrapper', {
                    'is-selected': isChosen,
                })}
            >
                <div
                    className="__app-CheckListItem-container"
                    styleName={cn('container', {
                        checked: isChosen,
                    })}
                    onClick={this.handleSelect}
                >
                    <CheckBox checked={isChosen} />
                    <div styleName="label">
                        <span>
                            <FormattedMessage {...messages.combination} />{' '}
                            <span className="__app-CheckListItem-combinationNumber">
                                {combinationNumber} / {betslipOddsSize}
                            </span>
                        </span>
                    </div>
                </div>
            </div>
        );
    }
}

const makeMapStateToProps = () => {
    return createSelector(selectCombinations, viewInfo => ({
        betslipOddsSize: undefined,
        combinations: undefined,
        isChosen: undefined,
        ...viewInfo,
    }));
};

const mapDispatchToProps = {
    toggleSystemCombination,
};

export default compose<React.ComponentClass<OwnProps>>(
    connect<MappedProps, MappedActions, OwnProps>(
        makeMapStateToProps,
        mapDispatchToProps
    ),
    withPure,
    withPropsValidation(['betslipOddsSize', 'combinations', 'isChosen'])
)(CheckListItem);
